import { Switch, Route } from 'react-router-dom'
import { withTransaction } from '@elastic/apm-rum-react'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useNotifyQuestCompleted } from 'state/vvsgotchi/hooks/useNotifyQuestCompleted'
import { GotchiToastListener } from 'contexts/ToastsContext/Listener'
import { Path } from 'config/constants/paths'

import Providers from './Providers'
import VvsGotchiConsole from './components/VvsGotchiConsole'
import ScreenStackRoute from './components/ScreenStackRoute'
import WalletStateWarnBanner from './components/WalletStateWarnBanner'
import VvsGotchiBgmPlayer from './components/BgmPlayer'

import { VvsGotchiScreen, StackContentFlex } from './styles'
import { useAcceptanceModal } from './AcceptanceModal'
import { useOnboardingModal } from './OnboardingModal'

import GotchiTeam from './Team'
import Quest from './Quest'
import MoleProfile from './MoleProfile'
import GotchiTeamSelect from './TeamSelect'
import FeedMole, { FeedMoleStackContentFlex } from './FeedMole'
import CleanMole from './CleanMole'
import QuestHistory from './QuestHistory'
import QuestDetail from './QuestDetail'
import { QuestFAQ, TeamFAQ } from './FAQ'
import Leaderboard from './Leaderboard'
import Gachapon from './Gachapon'
import Congrats from './Congrats'

const VvsGotchi = () => {
  const { account } = useActiveWeb3React()

  useAcceptanceModal()
  useOnboardingModal()
  useNotifyQuestCompleted(account)

  return (
    <VvsGotchiConsole>
      <VvsGotchiScreen>
        <WalletStateWarnBanner />

        <Switch>
          <Route path={Path.VVS_GOTCHI_TEAM}>
            <GotchiTeam />
          </Route>

          {/* base / default / fallback vvsgotchi app path page: */}
          <Route path={Path.VVS_GOTCHI}>
            <Quest />
          </Route>
        </Switch>

        <ScreenStackRoute path={Path.VVS_GOTCHI_MOLE_PROFILE}>
          <MoleProfile />
        </ScreenStackRoute>
        <ScreenStackRoute path={Path.VVS_GOTCHI_TEAM_SELECT}>
          <GotchiTeamSelect />
        </ScreenStackRoute>
        <ScreenStackRoute path={Path.VVS_GOTCHI_TEAM_FAQ}>
          <TeamFAQ />
        </ScreenStackRoute>
        <ScreenStackRoute
          path={Path.VVS_GOTCHI_TEAM_FEED}
          ContentFlex={FeedMoleStackContentFlex}
          backPath={Path.VVS_GOTCHI_TEAM}
        >
          <FeedMole />
        </ScreenStackRoute>
        <ScreenStackRoute
          path={Path.VVS_GOTCHI_TEAM_CLEAN}
          ContentFlex={StackContentFlex}
          backPath={Path.VVS_GOTCHI_TEAM}
        >
          <CleanMole />
        </ScreenStackRoute>
        <ScreenStackRoute
          path={Path.VVS_GOTCHI_TEAM_CONGRATS}
          ContentFlex={StackContentFlex}
          backPath={Path.VVS_GOTCHI_TEAM}
        >
          <Congrats />
        </ScreenStackRoute>

        <ScreenStackRoute path={Path.VVS_GOTCHI_QUEST_FAQ}>
          <QuestFAQ />
        </ScreenStackRoute>
        <ScreenStackRoute path={Path.VVS_GOTCHI_QUEST_HISTORY}>
          <QuestHistory />
        </ScreenStackRoute>
        <ScreenStackRoute path={Path.VVS_GOTCHI_QUEST_DETAIL}>
          <QuestDetail />
        </ScreenStackRoute>

        <Leaderboard />
        <Gachapon />
      </VvsGotchiScreen>
    </VvsGotchiConsole>
  )
}

const VvsGotchiWithProvider = () => {
  return (
    <Providers>
      <VvsGotchi />

      <GotchiToastListener />
      <VvsGotchiBgmPlayer />
    </Providers>
  )
}

export default withTransaction('VvsGotchiWithProvider', 'component')(VvsGotchiWithProvider)
